// src/components/admin/DeleteUserModal.jsx
import React, { useEffect, useState } from "react";
import { BsX, BsTrash } from "react-icons/bs";
import { useMemberStore } from "../../store/memberStore";

const CONFIRM_WORD = "SUPPRIMER";

const DeleteUserModal = ({ isOpen, onClose, member, onDeleted = () => {} }) => {
  const { deleteUser, actionLoading } = useMemberStore();
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (isOpen) setConfirmText("");
  }, [isOpen]);

  if (!isOpen || !member) return null;

  const canConfirm = confirmText.trim().toUpperCase() === CONFIRM_WORD;

  const handleDelete = async () => {
    if (!canConfirm) return;
    try {
      await deleteUser(member.id);
      onDeleted();
      onClose();
    } catch (error) {
      // Le message d'erreur est déjà affiché par le store
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white w-full max-w-md">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div>
            <h2 className="font-poppins font-semibold text-[18px] text-title">
              Supprimer le compte
            </h2>
            <p className="font-nunito text-[14px] text-text mt-1">
              {member.prenom} {member.nom}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 transition-colors"
            disabled={actionLoading}
          >
            <BsX size={24} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="flex items-center justify-center">
            <div className="p-3 bg-red-100">
              <BsTrash size={32} className="text-red-600" />
            </div>
          </div>

          <div className="font-nunito text-[14px] text-text space-y-2">
            <p>La suppression est définitive :</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>la personne ne pourra plus se connecter ;</li>
              <li>
                son e-mail et son téléphone sont effacés et pourront servir à
                une nouvelle inscription ;
              </li>
              <li>
                elle est retirée des rendez-vous à venir auxquels elle est
                assignée.
              </li>
            </ul>
            <p>
              Ses rendez-vous, paiements et abonnements sont conservés, avec
              son nom et son prénom.
            </p>
          </div>

          <label className="block font-nunito text-[14px] text-text">
            Pour confirmer, tapez <strong>{CONFIRM_WORD}</strong>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="mt-1 w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 font-nunito text-[14px]"
              autoComplete="off"
            />
          </label>
        </div>

        <div className="flex gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 font-nunito text-[14px] font-semibold hover:bg-gray-50 transition-colors"
            disabled={actionLoading}
          >
            Annuler
          </button>
          <button
            onClick={handleDelete}
            disabled={!canConfirm || actionLoading}
            className="flex-1 px-4 py-2 bg-red-600 text-white font-nunito text-[14px] font-semibold hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
          >
            {actionLoading ? "Suppression..." : "Supprimer le compte"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;
